import { apiClient } from './client';

export interface GlobalSettings {
  supportEmails: string[];
  bookAMeetingUrl: string | null;
}

interface GlobalSettingsApiResponse {
  data: GlobalSettings;
}

// Public, no-auth endpoint. Admin-editable copies of values that were hardcoded
// in the client; the envelope is unwrapped here like every other api module.
export const getGlobalSettings = async (): Promise<GlobalSettings> => {
  const response = await apiClient.get<GlobalSettingsApiResponse>(
    '/api/v1/global-settings'
  );
  return response.data;
};
